/* eslint-disable */
if (window.runtimePublicPath) {
    __webpack_public_path = window.runtimePublicPath;
}